"use client"

import { cn } from "@/lib/cn"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { ComponentPropsWithRef } from "react"
import { Img } from "./image"

export function Checkbox({
  className,
  checked,
  ref,
  ...props
}: ComponentPropsWithRef<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn("size-6", className)}
      checked={checked}
      {...props}
    >
      <CheckboxPrimitive.Indicator forceMount className={cn("size-6")}>
        <Img
          alt="checkbox status icon"
          src={
            checked
              ? "/assets/form/checkbox-checked.svg"
              : "/assets/form/checkbox-unchecked.svg"
          }
          width={24}
          height={24}
        />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}
